import _ from "lodash"

export default {
  methods: {
    $dd_register_type: function(key) {
      let data = [
        { key: "user", text: this.$t("global.dd_register_type_user") },
        { key: "company", text: this.$t("global.dd_register_type_company") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },
    $dd_modules: function(key) {
      let data = [
        { key: "users", text: this.$t("global.dd_modules_users") },
        { key: "roles", text: this.$t("global.dd_modules_roles") },
        { key: "permissions", text: this.$t("global.dd_modules_permissions") },
        { key: "settings", text: this.$t("global.dd_modules_settings") },
        { key: "logs", text: this.$t("global.dd_modules_logs") },
        { key: "queues", text: this.$t("global.dd_modules_queues") },
        { key: "persons", text: this.$t("global.dd_modules_persons") },
        { key: "companies", text: this.$t("global.dd_modules_companies") },
        {
          key: "certificates",
          text: this.$t("global.dd_modules_certificates"),
        },
      ]

      if (!this.$hasRole("system-developer")) {
        _.remove(data, item => item.key === "permissions")
        _.remove(data, item => item.key === "queues")
      }

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_action_models: function(key) {
      let data = [
        { key: "certificate", text: this.$t("certificates.title") },
        { key: "company", text: this.$t("companies.title") },
        { key: "permission", text: this.$t("global.dd_modules_permissions") },
        { key: "role", text: this.$t("global.dd_modules_roles") },
        { key: "setting", text: this.$t("global.dd_modules_settings") },
        { key: "user", text: this.$t("global.dd_modules_users") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_locales: function(key) {
      let data = [
        { key: "en", text: this.$t("global.dd_locales_en") },
        { key: "no", text: this.$t("global.dd_locales_no") },
        //{ key: 'nn', text: this.$t("global.dd_locales_nn") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_user_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_user_status_inactive") },
        { key: 1, text: this.$t("global.dd_user_status_active") },
        //{ key: 3, text: this.$t("global.dd_user_status_force_change") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_tennant_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_tennant_status_inactive") },
        {
          key: 1,
          text: this.$t("global.dd_tennant_status_active"),
          default: true,
        },
        {
          key: 2,
          text: this.$t("global.dd_tennant_status_not_created"),
          default: true,
        },
        {
          key: 3,
          text: this.$t("global.dd_tennant_status_in_progress"),
          default: true,
        },
        {
          key: 4,
          text: this.$t("global.dd_tennant_status_failed"),
          default: true,
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_titles: function(key) {
      let data = [
        { key: "Mr", text: this.$t("global.dd_titles_mr") },
        { key: "Mrs", text: this.$t("global.dd_titles_mrs") },
        { key: "Ms", text: this.$t("global.dd_titles_ms") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_templates_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_course_templates_status_inactive") },
        { key: 1, text: this.$t("global.dd_course_templates_status_active") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_template_types: function(key) {
      let data = [
        {
          key: "documented",
          text: this.$t("global.dd_course_template_types_documented"),
        },
        {
          key: "certified",
          text: this.$t("global.dd_course_template_types_certified"),
        },
        {
          key: "hotwork",
          text: this.$t("global.dd_course_template_types_hotwork"),
        },
        {
          key: "instructor_documented",
          text: this.$t(
            "global.dd_course_template_types_instructor_documented",
          ),
        },
        {
          key: "controller",
          text: this.$t("global.dd_course_template_types_controller"),
        },
        {
          key: "other",
          text: this.$t("global.dd_course_template_types_other"),
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_type_groups_status: function(key) {
      let data = [
        {
          key: 0,
          text: this.$t("global.dd_course_type_groups_status_inactive"),
        },
        {
          key: 1,
          text: this.$t("global.dd_course_type_groups_status_active"),
          default: true,
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_types_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_course_types_status_inactive") },
        {
          key: 1,
          text: this.$t("global.dd_course_types_status_active"),
          default: true,
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_attendees_theory_test: function(key) {
      let data = [
        { key: 1, text: this.$t("global.dd_attendees_theory_test_na") },
        { key: 2, text: this.$t("global.dd_attendees_theory_test_passed") },
        { key: 3, text: this.$t("global.dd_attendees_theory_test_failed") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_enrolment_status: function(key) {
      let data = [
        { key: 1, text: this.$t("global.dd_course_enrolment_status_enrolled") },
        {
          key: 2,
          text: this.$t("global.dd_course_enrolment_status_attending"),
        },
        {
          key: 3,
          text: this.$t("global.dd_course_enrolment_status_completed"),
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_classes_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_classes_status_inactive") },
        {
          key: 1,
          text: this.$t("global.dd_classes_status_active"),
          default: true,
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_classes_duration_type: function(key) {
      let data = [
        {
          key: 0,
          text: this.$t("global.dd_classes_duration_type_min"),
          default: true,
        },
        { key: 1, text: this.$t("global.dd_classes_duration_type_hours") },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_certificate_status: function(key) {
      let data = [
        { key: 0, text: this.$t("global.dd_certificate_status_not_confirmed") },
        {
          key: 1,
          text: this.$t("global.dd_certificate_status_confirmed"),
          default: true,
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },

    $dd_course_type_groups_type: function(key) {
      let data = [
        {
          key: 0,
          text: this.$t("global.dd_course_type_groups_type_certified"),
        },
        {
          key: 1,
          text: this.$t("global.dd_course_type_groups_type_documented"),
        },
        {
          key: 2,
          text: this.$t("global.dd_course_type_groups_type_undocumented"),
        },
      ]

      if (key !== undefined) {
        let item = data.find(i => i.key === key)
        return item ? item.text : ""
      }

      return data
    },
  },
}
